import {handleKeyPressEnterOrSpace} from '@wix/panda-js-utils'
import {useTranslation} from '@wix/yoshi-flow-editor'
import classes from 'animate.css'
import classNames from 'classnames'
import React, {useState} from 'react'
import {BI_SOURCE_PAGE} from '../../../../../../../../commons/bi/constants'
import cn from '../../../../classnames.scss'
import s from './add-to-calendar.scss'
import {AddToCalendarProps} from './interfaces'

const getCalendarOptionClasses = () => `${s.calendarOption} ${classes.animate__fadeInUp}`

export const AddToCalendar = ({
  buttonText,
  calendarLinks,
  className = '',
  dataHook = '',
  onClick,
  onOptionClick,
}: AddToCalendarProps) => {
  const {t} = useTranslation()
  const [optionsVisible, setOptionsVisible] = useState(false)

  const addToCalendar = () => {
    setOptionsVisible(!optionsVisible)
    onClick()
  }

  return (
    <div data-hook={dataHook}>
      <button
        className={classNames(className, {[s.optionsSpacing]: optionsVisible})}
        data-hook="add-to-calendar"
        aria-expanded={optionsVisible}
        onClick={addToCalendar}
      >
        {buttonText}
      </button>
      {optionsVisible && (
        <div className={classNames(s.calendarOptions, cn.formTitleColor, cn.formLabelsFont)}>
          <a
            target="_blank"
            rel="noreferrer"
            href={calendarLinks.google}
            className={getCalendarOptionClasses()}
            data-hook="calendar-google"
            tabIndex={0}
            aria-label={t('a11y.calendarButtonLabel', {
              button: 'Google Calendar',
            })}
            onClick={() => onOptionClick({origin: 'Google', sourcePage: BI_SOURCE_PAGE.ORDER_SUCCESS})}
            onKeyPress={handleKeyPressEnterOrSpace(() => window.open(calendarLinks.google))}
          >
            Google
          </a>
          <a
            target="_blank"
            rel="noreferrer"
            href={calendarLinks.ics}
            className={`${getCalendarOptionClasses()} ${s.delayAnimationHalf}`}
            data-hook="calendar-outlook"
            tabIndex={0}
            aria-label={t('a11y.calendarButtonLabel', {
              button: 'Outlook',
            })}
            onClick={() => onOptionClick({origin: 'Outlook', sourcePage: BI_SOURCE_PAGE.ORDER_SUCCESS})}
            onKeyPress={handleKeyPressEnterOrSpace(() => window.open(calendarLinks.ics))}
          >
            Outlook
          </a>
          <a
            target="_blank"
            rel="noreferrer"
            href={calendarLinks.ics}
            className={`${getCalendarOptionClasses()} ${s.delayAnimationOne}`}
            data-hook="calendar-ical"
            tabIndex={0}
            aria-label={t('a11y.calendarButtonLabel', {
              button: 'iCal',
            })}
            onClick={() => onOptionClick({origin: 'iCal', sourcePage: BI_SOURCE_PAGE.ORDER_SUCCESS})}
            onKeyPress={handleKeyPressEnterOrSpace(() => window.open(calendarLinks.ics))}
          >
            iCal
          </a>
        </div>
      )}
    </div>
  )
}
